// Cross-component event so any deeply-nested component (e.g. a product
// modal) can ask the Header-owned LoginModal to open without requiring
// prop drilling through every layer.
export const OPEN_LOGIN_EVENT = 'neobox:open-login';
